"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationType = exports.ExecuteType = exports.FieldCollectionType = exports.DISPLAY_NAME = exports.TITLE_FIELD = exports.ITEM_ID_DISPLAY_FIELD = exports.PAYMENT_DISPLAY_FIELD = exports.SUBMISSION_DISPLAY_FIELD = void 0;
exports.SUBMISSION_DISPLAY_FIELD = 'submissionTime';
exports.PAYMENT_DISPLAY_FIELD = 'paymentTransactionId';
exports.ITEM_ID_DISPLAY_FIELD = 'dynamicPageId';
exports.TITLE_FIELD = 'title';
exports.DISPLAY_NAME = 'displayName';
var FieldCollectionType;
(function (FieldCollectionType) {
    FieldCollectionType["TEXT"] = "text";
    FieldCollectionType["IMAGE"] = "image";
    FieldCollectionType["BOOLEAN"] = "boolean";
    FieldCollectionType["NUMBER"] = "number";
    FieldCollectionType["DATETIME"] = "datetime";
    FieldCollectionType["TIME"] = "time";
    FieldCollectionType["RICHTEXT"] = "richtext";
    FieldCollectionType["COLOR"] = "color";
    FieldCollectionType["REFERENCE"] = "reference";
    FieldCollectionType["MULTI_REFERENCE"] = "multi-reference";
    FieldCollectionType["PAGELINK"] = "pagelink";
    FieldCollectionType["URL"] = "url";
    FieldCollectionType["DOCUMENT"] = "document";
    FieldCollectionType["VIDEO"] = "video";
    FieldCollectionType["ADDRESS"] = "address";
    FieldCollectionType["OBJECT"] = "object";
    FieldCollectionType["TAGS"] = "array<string>";
})(FieldCollectionType = exports.FieldCollectionType || (exports.FieldCollectionType = {}));
var ExecuteType;
(function (ExecuteType) {
    ExecuteType["CREATE"] = "CREATE";
    ExecuteType["UPDATE"] = "UPDATE";
    ExecuteType["REMOVE"] = "REMOVE";
    ExecuteType["RESTORE"] = "RESTORE";
})(ExecuteType = exports.ExecuteType || (exports.ExecuteType = {}));
var OperationType;
(function (OperationType) {
    OperationType["ADD"] = "add";
    OperationType["REMOVE"] = "remove";
})(OperationType = exports.OperationType || (exports.OperationType = {}));
//# sourceMappingURL=wixcode.js.map